import React, { FC } from "react";
import FacebookIcon from "../../atoms/icons/Facebook";
import TwitterIcon from "../../atoms/icons/Twitter";
import InstagramIcon from "../../atoms/icons/Instagram";
import LinkedInIcon from "../../atoms/icons/LinkedIn";
import YoutubeIcon from "../../atoms/icons/Youtube";
import TiktokIcon from "../../atoms/icons/Tiktok";
import SpotifyIcon from "../../atoms/icons/Spotify";
import { CategoryContent } from "components/organisms/footer/footer";

type SocialMediaIconType =
    | "icon-facebook"
    | "icon-twitter"
    | "icon-Instagram"
    | "icon-linkedin"
    | "icon-youtube1"
    | "tiktok"
    | "spotify";

const SocialMediaIconsMap: Record<
    SocialMediaIconType,
    FC<React.SVGProps<SVGSVGElement>>
> = {
    "icon-facebook": FacebookIcon,
    "icon-twitter": TwitterIcon,
    "icon-Instagram": InstagramIcon,
    "icon-linkedin": LinkedInIcon,
    "icon-youtube1": YoutubeIcon,
    tiktok: TiktokIcon,
    spotify: SpotifyIcon,
};

interface SocialMediaIconsProps {
    content: CategoryContent;
}

const SocialMediaIcons = ({ content }: SocialMediaIconsProps) => {
    return (
        <div>
            <h5 className="o_footer__title">{content.nombreCategoria}</h5>
            <div className="social-media">
                {content.referenciaSubcategorias.map((socialMedia) => {
                    const iconType =
                        socialMedia?.tipoCampo as SocialMediaIconType;
                    const SocialMediaIcon = SocialMediaIconsMap[iconType];
                    if (!SocialMediaIcon || !socialMedia?.link) return null;
                    return (
                        <a
                            aria-label={socialMedia?.nombreSubcategoria}
                            className="social-media__item"
                            title={socialMedia?.nombreSubcategoria}
                            key={`${iconType}-${socialMedia?.link}`}
                            href={socialMedia?.link}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <SocialMediaIcon />
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default SocialMediaIcons;
